export const DEFAULT_COUNT_DOWN = 3; // seconds
export const DEFAULT_DURATION = 60; // seconds
export const DEFAULT_ATTEMPTS = 3; // number of attempts
export const DEFAULT_THINKING_TIME = 0; // seconds
export const ENOUGH_RECORDING_TIME = 3; // seconds
export const SPEED_TEST_FILE_SIZE = 5; // MB
export const FAST_UPLOAD_SPEED = 0.35; // MB/s
export const SLOW_UPLOAD_SPEED = 0.1; // MB/s
export const SPEED_TEST_TIMEOUT = 5000; // 5s
export const VIDEO_INACTIVE_TIMEOUT = 2000; // 2s
export const MICROPHONE_NO_SOUND_ERROR_CODE = 777;
export const MAX_FAILED_RECORDING_ATTEMPTS = 2;
export const SECONDS_LEFT_HIGHLIGHT = 10;
export const DEFAULT_ASSESSMENT_MAX_CHARS = 300;
export const DEFAULT_ASSESSMENT_DURATION = 0;
export const DEFAULT_VIDEO_DIMENSIONS = { width: 1280, height: 720 }; // Transcoder default dimensions (720p)
export const MAX_CONFIRM_ATTEMPTS = 5;

// Font
export const FONT_URL = 'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&display=swap';

export enum RETAKE_SPEED {
  FAST = 300, // 5 second
  MEDIUM = 420, // 7 seconds
  DISABLED = Infinity, // no timing
}
